import { render, staticRenderFns } from "./PowerChatMain.vue?vue&type=template&id=5c11edb0&scoped=true"
import script from "./PowerChatMain.vue?vue&type=script&lang=js"
export * from "./PowerChatMain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c11edb0",
  null
  
)

export default component.exports